export default __webpack_public_path__ + "static/media/eye-alt.b57e45fc.svg";